/* Copyright (c) 2020-present CloudIO Inc */

// Copy this file to src/componentregistry/components/Alert folder
// and import helpRenders into AlertManager.ts file
//

import { ComponentSample, Item } from 'componentregistry';

const page: {
  a1: Item<'Alert'>;
  root: Item<'Page'>;
  flexPanel: Item<'FlexPanel'>;
  flexItem: Item<'FlexItem'>;
  triggerOnClick: Item<'TriggerOnClick'>;
  actionShowMessage: Item<'ActionShowMessage'>;
} = {
  a1: {
    children: ['triggerOnClick'],
    itemId: 'a1',
    parent: 'flexItem',
    props: {
      actionText: 'Click me',
      alertText: {
        type: 'text',
        value: 'This is an alert — check it out!',
      },
    },
    type: 'Alert',
  },
  actionShowMessage: {
    children: [],
    itemId: 'actionShowMessage',
    parent: 'triggerOnClick',
    props: {
      message: {
        type: 'text',
        value: 'You click an alert!',
      },
      type: 'info',
    },
    type: 'ActionShowMessage',
  },
  flexItem: {
    children: ['a1'],
    itemId: 'flexItem',
    parent: 'flexPanel',
    props: {},
    type: 'FlexItem',
  },
  flexPanel: {
    children: ['flexItem'],
    itemId: 'flexPanel',
    parent: 'root',
    props: {},
    type: 'FlexPanel',
  },
  root: {
    children: ['flexPanel'],
    itemId: 'root',
    parent: 'root',
    props: {
      windowTitle: {
        type: 'text',
        value: 'CloudIO Help',
      },
    },
    type: 'Page',
  },
  triggerOnClick: {
    children: ['actionShowMessage'],
    itemId: 'triggerOnClick',
    parent: 'a1',
    props: {},
    type: 'TriggerOnClick',
  },
};

export const helpRenders: ComponentSample<'Alert'>[] = [
  {
    title: 'Alert',
    description: 'Sample Alert',
    page,
    exampleId: 'e1',
    clearParentChildren: true,
    visibleProps: ['alertText', 'severity', 'variant'],
    item: {
      itemId: 'a1',
      props: {
        alertText: {
          type: 'text',
          value: 'This is an alert — check it out!',
        },
        actionText: '',
      },
      children: [],
      type: 'Alert',
      parent: 'columnPanel1',
    },
  },
  {
    title: 'Alert',
    description:
      'With actionionable link. You can use Trigger On Click to perform neccessary actions.',
    page,
    exampleId: 'eg-01FYT4JRN34ADSJZEMBRVS04AJ',
    clearParentChildren: true,
    height: 280,
    visibleProps: ['actionText'],
    item: {
      type: 'Alert',
      props: {
        alertText: {
          type: 'text',
          value: 'This is an alert — check it out!',
        },
        actionText: 'Click me',
      },
      itemId: 'a1',
      parent: 'flexItem',
      children: ['triggerOnClick'],
    },
  },
  {
    title: 'Alert',
    description: 'With Title',
    page,
    exampleId: 'e3',
    clearParentChildren: true,
    visibleProps: ['alertTitle'],
    item: {
      itemId: 'a1',
      props: {
        alertText: {
          type: 'text',
          value: 'This is an alert — check it out!',
        },
        alertTitle: {
          type: 'text',
          value: 'Note!',
        },
      },
      children: [],
      type: 'Alert',
      parent: 'flexItem',
    },
  },
];
